import React from "react";

const UICheckbox = ({
    name,
    labelClassName,
    label,
    type = 'checkbox',
    value,
    required,
    error,
    onChange,
    isDisclaimer,
    hasAlignment = true,
    props,
}) => {
    return (
        <div className="ui-input-component">
            <label
                htmlFor={name}
                className={`checkbox-label ${labelClassName} ${(hasAlignment && !isDisclaimer) ? 'checkbox-label--centered' : ''}`}
            >
                <span className="checkbox-container">
                    <input
                        type={type}
                        name={name}
                        checked={value ?? false}
                        onChange={(e) => onChange(e.target.checked)}
                        required={required}
                        className={error ? 'input-error' : ''}
                        {...props}
                    />
                </span>
                {required && <>&nbsp;</>}
                {!!label && (
                    <span
                        dangerouslySetInnerHTML={{__html: label}}
                        className={isDisclaimer ? 'checkbox-disclaimer' : 'checkbox-text'}
                    />
                )}
            </label>
        </div>
    );
};

export default UICheckbox;
